import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPause: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPause"><Path d="M4.5 3.5H9.5V20.5H4.5V3.5Z" stroke="currentColor"/><Path d="M14.5 3.5H19.5V20.5H14.5V3.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconPause;
